<mat-card>
  <mat-card-header>
    <mat-card-title>{{ 'website.equipment.detail.charts.elements_display' | translate }}</mat-card-title>
  </mat-card-header>

  <mat-card-content class='card-filter-content' >
    <ng-container *ngFor="let filterCategory of filterCategoriesSignal(); let parentIndex = index" class=' pt-2 pb-2'>
      <mat-expansion-panel class='h-100    mat-elevation-z0 expansion-content' [expanded]="isExpanded()(parentIndex)" >
        <mat-expansion-panel-header class='h-100 header-expansion ' >
          <mat-checkbox  [color]="'primary'" [checked]="filterCategory.checked"       [indeterminate]="partiallyComplete()(parentIndex)" (change)="update($event.checked, parentIndex)"></mat-checkbox>
          <div  >
            <mat-panel-title class='header-expansion-title  '>{{ filterCategory.translationSlug | translate }}</mat-panel-title>
            <mat-panel-description class='header-expansion-description'
            >{{ getCheckedFiltersInCategoryCount()(parentIndex) }}/{{ getAvailableFiltersInCategoryCount()(parentIndex) }}
              {{ 'website.equipment.detail.charts.selected' | translate }}</mat-panel-description
            >
          </div>
        </mat-expansion-panel-header>

        <mat-list >
          <ng-container *ngFor="let filterItem of filterCategory.filters ; let childIndex = index">
            <mat-list-item class='ps-1'  *ngIf="!filterItem.filterButNotDisplay">
              <mat-checkbox  [color]="'primary'" [disabled]="filterItem.disable" [checked]="filterItem.checked"  (change)="update($event.checked, parentIndex,childIndex)"></mat-checkbox>
              <span style='text-wrap: wrap;' class='checkbox-expansion-label'>
                          {{ filterItem.translationSlug | translate }}&nbsp;
                        <span *ngIf="filterItem?.valueSuffix && !filterItem.hideValueSuffix ">({{filterItem.valueSuffixConverted??filterItem.valueSuffix }}<span *ngIf="filterItem?.timeUnit">
  /{{ filterItem.timeUnit }}</span>)</span>
                        </span>

            </mat-list-item>
          </ng-container>
        </mat-list>
      </mat-expansion-panel>

    </ng-container>
  </mat-card-content>
  <mat-card-actions [align]='"end"'>
    <button mat-flat-button class='my-2 pv-button-grey ' [disabled]="isLoading" (click)="resetFilters()">
      {{ 'website.equipment.detail.charts.reset' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
